import { CallsTypes } from "@/enums/CallsTypes";
import { UserTypeEnum } from "@/enums/UserTypeEnum";
import moment from "moment";
import * as firebase from "firebase/app";

export const mapCallsToEvents = (calls: any[]) => {

  if(!calls?.length) return [];

  if(calls[0].callType === CallsTypes.ScheduledCall){
    return calls.filter((x: any) => x?.participants?.some((p: any)=>p.role === UserTypeEnum.Resident))
            .map((data: any) => {
                const startDate = moment(data.scheduledAt.seconds * 1000).toDate()
                const start = data.scheduledAt 
                const end = firebase.firestore.Timestamp.fromDate(moment(startDate).add(1, 'hour').toDate())
                const callCreator = data.participants?.find(x=>x.isHost === true)
                const inviterName = callCreator?.name || '' 
                const callResident = callCreator?.role === UserTypeEnum.Resident ? callCreator: 
                (data?.callCancelReason && data?.cancelledByRole === UserTypeEnum.Resident ? {
                  id: data.callCancelReason.cancelledById,
                  avatar: data.callCancelReason.cancelledByAvatar,
                  name: data.callCancelReason.cancelledByName,
                  role: data.callCancelReason.cancelledByRole,
                }: null) || data.participants?.find(x=>x.role === UserTypeEnum.Resident)
                return {
                    ...data,
                    startDate: startDate,
                    start: start,
                    end: end,
                    type: CallsTypes.ScheduledCall,
                    inviterName: inviterName,
                    callResident: callResident,
                    isPublished: true,
                    going: [],
                    invitees: [],
                };
            });
  } else if(calls[0].callType === CallsTypes.RealtimeCall){
     return calls.filter((x: any) => x?.participants?.some((p: any)=>p.role === UserTypeEnum.Resident))
        .map((data: any) => {
            const startDate = data.start ? moment(data.start.seconds * 1000).toDate() : null
            const start = data.start
            const end = data.end || data.start
            const callCreator = data.participants?.find(x=>x.isHost === true)
            const inviterName = callCreator?.name || ''
            const callResident = callCreator?.role === UserTypeEnum.Resident ? callCreator: 
            (data?.callCancelReason && data?.cancelledByRole === UserTypeEnum.Resident ? {
              id: data.callCancelReason.cancelledById,
              avatar: data.callCancelReason.cancelledByAvatar,
              name: data.callCancelReason.cancelledByName,
              role: data.callCancelReason.cancelledByRole,
            }: null) || data.participants?.find(x=>x.role === UserTypeEnum.Resident)
            return {
                ...data,
                startDate: startDate,
                start: start,
                end: end,
                type: CallsTypes.RealtimeCall,
                inviterName: inviterName,
                callResident: callResident,
                isPublished: true,
                going: [],
                invitees: [],
            };
        });
  }
  else{
    return []
  }
};


